import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    staticClass: "dialog",
    attrs: {
      title: "切换企业",
      visible: _vm.dialogVisible,
      width: "35%"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      },
      close: _vm.handleClose
    }
  }, [[_c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "list"
  }, _vm._l(_vm.list, function (item) {
    return _c("div", {
      key: item.id,
      class: ["item", _vm.current === item.id ? "active" : ""],
      on: {
        click: function click($event) {
          return _vm.changeActive(item.id);
        }
      }
    }, [_vm.current === item.id ? _c("img", {
      staticClass: "icon",
      attrs: {
        src: require("@/assets/company/icon-company-active.png"),
        alt: ""
      }
    }) : _c("img", {
      staticClass: "icon",
      attrs: {
        src: require("@/assets/company/icon-company.png"),
        alt: ""
      }
    }), _vm._v(" "), _c("div", {
      staticClass: "title"
    }, [_c("div", [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm.current === item.id ? _c("div", {
      staticClass: "current"
    }, [_vm._v("当前企业")]) : _vm._e()]), _vm._v(" "), _vm.current === item.id ? _c("img", {
      staticClass: "select",
      attrs: {
        src: require("@/assets/company/icon-select.png"),
        alt: ""
      }
    }) : _vm._e()]);
  }), 0), _vm._v(" "), _c("div", {
    staticClass: "add",
    on: {
      click: _vm.goAdd
    }
  }, [_c("img", {
    staticClass: "add_icon",
    attrs: {
      src: require("@/assets/company/icon-add.png"),
      alt: ""
    }
  }), _vm._v("\n      添加企业\n    ")]), _vm._v(" "), _c("div", {
    staticClass: "footer"
  }, [_c("el-button", {
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.ok
    }
  }, [_vm._v("确定")])], 1)]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };